import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearIncidentPopups, resetIncident } from '~/actions';
import { useReportIncidentMutation } from '~/domain/Jobs';

export const useReportIncidentPopup = () => {
  const { incident, showReportIncidentPopup, reportIncidentPopupState } = useSelector(
    (state) => state.job,
  );
  const { incidentType, job } = incident;

  const dispatch = useDispatch();

  const { mutate: submitIncident, isPending: isLoading } = useReportIncidentMutation();

  const submitReportIncident = useCallback(() => {
    const jobId = job?.id;

    if (!jobId) {
      return;
    }

    submitIncident({ jobId, incidentType });
  }, [submitIncident, incidentType, job?.id]);

  const closeReportIncident = useCallback(() => {
    dispatch(clearIncidentPopups());
    dispatch(resetIncident());
  }, [dispatch]);

  return {
    isLoading,
    incident,
    incidentType,
    showReportIncidentPopup,
    submitReportIncident,
    closeReportIncident,
    reportIncidentPopupState,
  };
};
